interface ParseSelect {
  array: any[]
  labelKey: string
  valueKey: string
}

export const parseSelect = ({ array, labelKey, valueKey }: ParseSelect) =>
  array.map((el) => ({ label: el[labelKey], value: el[valueKey] }));
